export var PersonalFoulOptions = [
  "shooting",
  "looseBall",
  // "flagrantType1",
  // "flagrantType2",
];

export var TechnicalFoulOptions = ["block", "charge"];
